import {mapGetters, mapMutations} from "vuex";

export default {
    computed: {
        ...mapGetters({
            getConfirmationDialogOpen: 'customizer/getConfirmationDialogOpen',
            getConfirmationDialogStep: 'customizer/getConfirmationDialogStep',
            getConfirmationDialogConfirm: 'customizer/getConfirmationDialogConfirm',
            getConfirmationDialogData: 'customizer/getConfirmationDialogData',
            getStep: 'customizer/getStep'
        }),
    },
    methods: {
        ...mapMutations({
            setConfirmationDialogOpen: 'customizer/setConfirmationDialogOpen',
            setConfirmationDialogStep: 'customizer/setConfirmationDialogStep',
            setConfirmationDialogConfirm: 'customizer/setConfirmationDialogConfirm',
            setConfirmationDialogData: 'customizer/setConfirmationDialogData',
            setAdditionals: 'customizer/setAdditionals',
            setComplementary: 'customizer/setComplementary',
            setOption: 'customizer/setOption',
            setOptionGroup: 'customizer/setOptionGroup',
            setOptionFabric: 'customizer/setOptionFabric'
        }),
        compareValues(n, o) {
            return o && n !== o && this.getOptions.pa_additionals.length
        },

        compareValuesFabric(n, o) {
            return o && n !== o && this.getOptions.pa_additionals.length
        },

        compareValuesComplementary(n, o) {
            return o && n !== o && this.getOptions.pa_materac
        },
        openConfirmDialog() {
            this.setConfirmationDialogOpen(true)
            this.setConfirmationDialogStep(this.getStep.id)
        },
        acceptConfirmDialog() {
            this.setConfirmationDialogOpen(false)
            this.setConfirmationDialogConfirm(true)
        },
        cancelConfirmDialog() {
            this.setConfirmationDialogOpen(false)
            this.setConfirmationDialogStep(null)
            this.restoreFabric()
        },
        closeConfirmDialog() {
            this.setConfirmationDialogOpen(false)
            this.setConfirmationDialogStep(null)
            this.setConfirmationDialogConfirm(false)
        },
        restoreFabric() {
            this.setOptionGroup(this.getConfirmationDialogData.group)
            this.setOptionFabric(this.getConfirmationDialogData.fabric)
        }
    }
}
